<template lang="pug">

tr
    //- Username
    td: router-link(v-bind:to='{ name: "users/update", params: { id: userModel.id }}') {{ userModel.username }}

    //- Unternehmen
    td: router-link(v-bind:to='{ name: "companies/update", params: { id: companyModel.id } }') {{ companyName }}

    //- Vorname
    td {{ firstName }}

    //- Nachname
    td {{ lastName }}

    //- E-Mail
    td {{ email }}

    //- Status
    td.center.aligned
        i.unlock.alternate.icon(v-show='userModel.status === "HAS_ACCESS"' v-tooltip='"Zugang ist aktiv"')
        i.lock.icon(v-show='userModel.status === "HAS_NO_ACCESS"' v-tooltip='"Zugang ist inaktiv"')

</template>

<script>
    import * as R from 'ramda'

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {
            companyModel() {
                return R.compose(

                    // ggf. Default-Wert setzen
                    R.defaultTo({}),

                    // Unternehmen zu Person finden
                    R.find(R.propEq('id', this.personModel.company))

                )(this.companyModels)
            },

            companyName() {
                return R.defaultTo('-', this.companyModel.name)
            },

            email() {
                return R.defaultTo('-', this.personModel.email)
            },

            firstName() {
                return R.defaultTo('-', this.personModel.firstName)
            },

            lastName() {
                return R.defaultTo('-', this.personModel.lastName)
            },

            personModel() {
                return R.compose(

                    // ggf. Default-Wert setzen
                    R.defaultTo({}),

                    // Person zu Benutzer finden
                    R.find(R.propEq('id', this.userModel.person))

                )(this.personModels)
            }
        },

        props: {

            companyModels: {
                type: Array,
                required: true
            },

            userModel: {
                type: Object,
                required: true
            },

            personModels: {
                type: Array,
                required: true
            }

        }

    }

</script>
